import React from "react";
import styles from "./About.module.css";
import Typical from "react-typical";
import { Box, Button, Hide, Show, SimpleGrid, Text } from "@chakra-ui/react";
import myImg from "./Image/profile.jpg";
import Resume from "./Image/Vivek_Rana_Resume.pdf";
import { FaGithub, FaLinkedin } from "react-icons/fa";

import { motion } from "framer-motion";
import { Link } from "react-scroll";
import Icons from "./Icons";
const About = () => {
  const handleDownload = () => {
    window.open(
      "https://drive.google.com/file/d/1gbDiyd9Wkv9zEulCPvp3LuH8BW1Lz74C/view?usp=share_link",
      "_blank"
    );
  };
  return (
    <>
      <SimpleGrid
        columns={[1, 1, 1, 2]}
        name="Navbar"
        mb={"5%"}
        id="home"
        className={styles.intro}
      >
        <Show below="lg">
          <Box className="home-img" mt={"10%"}>
            <motion.div whileHover={{ scale: 1.1 }} className={styles.right}>
              <img className={styles.my_img} src={myImg} alt="my_Image" />
            </motion.div>
          </Box>
        </Show>

        <Box className={styles.left}>
          <div className={styles.name}>
            <div className={styles.icons}>
              <Icons />
            </div>

            <Text
              id="user-detail-name"
              fontWeight="bold"
              fontSize="2rem"
              color={"black"}
            >
              {" "}
              Hello,I am Vivek Rana
            </Text>
            <Hide below="md">
              <Text
                fontWeight="normal"
                fontSize="2.5rem"
                color={"#f4e16a"}
                className={styles.typical}
              >
                <h1 id="#about.about.section">
                  <Typical
                    loop={Infinity}
                    steps={[
                      "A Full Stack Web Developer",
                      1500,
                      "A MERN Stack Developer",
                      1500,
                    ]}
                  />
                </h1>
              </Text>
            </Hide>

            <Text
              fontWeight="normal"
              fontSize="1.2rem"
              color={"black"}
              id="user-detail-intro"
              className={styles.info}
            >
              Dedicated and efficient full stack web developer with 1200+ hours
              of coding and solved 100+ numbers of DSA questions, with good
              problem solving skills. Seeking to further improve my skills as
              the company's future full stack web developer.
            </Text>
          </div>
          <div className={styles.hire}>
            <Link to="contact" spy={true} smooth={true}>
              <Button
                _focus={{ outline: "none" }}
                className={styles.hire_btn}
                width={"130%"}
                textColor={"white"}
                backgroundColor={"black"}
              >
                Hire
              </Button>
            </Link>

            <a
              id="resume-link-2"
              onClick={handleDownload}
              href={Resume}
              download
              style={{ textDecoration: "none" }}
            >
              <Button
                id="resume-button-2"
                _focus={{ outline: "none" }}
                width={"130%"}
                textColor={"white"}
                backgroundColor={"black"}
              >
                Download Resume
              </Button>
            </a>
          </div>
        </Box>
        <Hide below="lg">
          <Box>
            <motion.div whileHover={{ scale: 1.1 }} className={styles.right}>
              <img className={styles.my_img} src={myImg} alt="my_Image" />
            </motion.div>
          </Box>
        </Hide>
      </SimpleGrid>
    </>
  );
};

export default About;
